import styled from '@emotion/styled';
import CalendarIcon from '../../../images/calendar.svg';
import { ReactComponent as WarnIcon } from '../../../images/warning.svg';
import { ReactComponent as LabelIcon } from '../../../images/label.svg';
import { ReactComponent as CircleCrsIcon } from '../../../images/circleCrs.svg';
import { ReactComponent as RepeatIcon } from '../../../images/repeat.svg';

import { ReactComponent as BagIcon } from '../../../images/bag.svg';
import { ReactComponent as EyeIcon } from '../../../images/eye.svg';
import { ReactComponent as IncIcon } from '../../../images/inc.svg';
import { ReactComponent as DecIcon } from '../../../images/dec.svg';
import { ReactComponent as TrashIcon } from '../../../images/trash.svg';
import { ReactComponent as EditIcon } from '../../../images/edit.svg';
import { ReactComponent as RegularIcon } from '../../../images/arrow/rotate-360.svg';
import { ReactComponent as DownIconNon } from '../../../images/arrow/downnonecol.svg';
import DownIcon from '../../../images/arrow/down.svg';
import { Link } from 'react-router-dom';

export const IconLabel = styled(LabelIcon)`

display: none;
@media (max-width: 689px) {
  display: block;
    width: 24px;
  height: 24px;

  } 


`;

export const IconCircleCrs = styled(CircleCrsIcon)`

display: none;
@media (max-width: 689px) {
   display: block;
    width: 24px;
  height: 24px;

  } 


`;
export const IconRepeat = styled(RepeatIcon)`

display: none;
@media (max-width: 689px) {
   display: block;
    width: 24px;
  height: 24px;

  } 


`;



export const BagsBox = styled.div`
border-radius: 16px;
padding: 16px;
padding-bottom: 16px;
min-width: 1024px;
width: 100%;
height: fit-content;
background: var(--colors-grey-50);


  @media (max-width: 1440px) {
    min-width: 872px;
  } 
@media (max-width: 1024px) {
    min-width: 616px;
  } 
  @media (max-width: 844px) {
    min-width: 342px;
  } 

`;



export const BagsTitleBox = styled.div`
  display: flex;
align-items: flex-start;
justify-content: space-between;
border-bottom: 1px solid var(--colors-grey-200);
padding: 0px 0px 12px 0px;
width:100%;

margin-bottom: 16px;
@media (max-width: 689px) {

  align-items: flex-end;
  } 

`;

export const BagsBodyBox = styled.div`
width: 100%;
height: fit-content;
padding: 16px 0 0 0;
min-height: fit-content;
`;


export const BagsTitle = styled.div`
display: flex;
align-items: center;
gap:8px;

max-width: 40%;
@media (max-width: 689px) {
  flex-direction: column-reverse;
  align-items: flex-start;
  } 

`;

export const BGTitle = styled.h2`

font-family: var(--font-family);
font-weight: 600;
font-size: 20px;
line-height: 135%;
color: var(--colors-grey-800);

height: fit-content;
 white-space: nowrap; /* Текст не буде переноситись */
  overflow: hidden; /* Приховує текст, який виходить за межі елемента */
  text-overflow: ellipsis; 
  @media (max-width: 689px) {
 width:230px;
  } 
`;

export const BagsStatus = styled.span`
font-family: var(--font-family);
font-weight: 500;
font-size: 14px;
line-height: 150%;
color: var(--colors-grey-25);
background-color: ${props => props.statusCol};
border-radius: 360px;
padding: 4px 12px;
white-space: nowrap;
`;

export const IconEye = styled(EyeIcon)`
  width: 22px;
  height: 20px;
  font-size: 24px;
  stroke: var(--colors-primary-600);
  margin-right: 12px;
  color: var(--colors-grey-25);
  @media (max-width: 689px) {
     margin-right: 0px;
  } 
`;
export const IconWarn = styled(WarnIcon)`
  width: 20px;
  height: 20px;

  stroke: currentColor;
  margin-right: 12px;
  stroke: var(--colors-warning-500);
`;

export const IconBag = styled(BagIcon)`
  width: 20px;
  height: 20px;
  margin-right: 12px;
  stroke: currentColor;

`;
export const IconInc = styled(IncIcon)`
  width: 16px;
  height: 17px;
  font-size: 24px;
  stroke:  var(--colors-secondary-500);
 
  color: var(--colors-secondary-500);
`;

export const IconDec = styled(DecIcon)`
  width: 16px;
  height: 3px;
  font-size: 24px;
  stroke:${props => props.disabled ? 'var(--colors-secondary-500)' : 'var(--colors-grey-300)'} ;


  color: var(--colors-grey-300);
`;
export const IconReg = styled(RegularIcon)`
  width: 20px;
  height: 20px;
  font-size: 24px;
  stroke: var(--colors-grey-300);

  color: var(--colors-grey-300);
`;

export const IconTrash = styled(TrashIcon)`
  width: 24px;
  height: 24px;
 

`;

export const Span= styled.span`
@media (max-width: 844px) {
  display: none;
  } 
`;
export const Span1 = styled.span`
@media (max-width: 689px) {
  display: none;
  } 
`;


export const IconEdit = styled(EditIcon)`
  width: 24px;
  height: 24px;
fill: currentColor;
&.mob{
    display: none;
   }
@media (max-width: 844px) {
   &.mob{
    display: block;
   fill: var(--colors-primary-600);
   }
  } 

`;


export const IconDown = styled(DownIconNon)`
  width: 24px;
  height: 24px;

  stroke: var(--colors-error-600);

 
`;

export const WrapIcon = styled.span`
border-radius: 360px;
width: 32px;
height: 32px;
backdrop-filter: blur(4px);
background: var(--colors-grey-25);
display: flex;
align-items: center;
justify-content: center;
`;




export const BagsNoText = styled.p`
font-family: var(--font-family);
font-weight: 500;
font-size: 16px;
line-height: 137%;
text-align: center;
color: var(--colors-grey-500);
`;


export const ButtonWrap = styled.div`

display: flex;
align-items: center;
gap:8px;
`;
export const PreviewButton = styled.button`
font-family: var(--font-family);
font-weight: 600;
font-size: 16px;
line-height: 137%;
text-align: center;
display: flex;
align-items: center;
color: var(--colors-primary-600);
background:none;
border-radius: 360px;
padding: 8px 24px;
cursor: pointer;
@media (max-width: 689px) {
    padding: 0;
  } 
`;



export const SaleButton = styled.button`
font-family: var(--font-family);
font-weight: 600;
font-size: 16px;
line-height: 137%;
text-align: center;
display: flex;
align-items: center;
color: var(--colors-grey-25);
background-color: ${props => props.statusBtnCol};
border-radius: 360px;
padding: 8px 24px;
cursor: pointer;
@media (max-width: 689px) {
    border-radius: 8px;
padding: 8px 8px;
width: 32px;
height: 32px;
  } 
`;


export const ChangeButton = styled.button`
font-family: var(--font-family);
font-weight: 600;
font-size: 16px;
line-height: 137%;
text-align: center;
color: var(--colors-primary-600);

display: flex;
align-items: center;

background:none;
border: 1px solid var(--colors-primary-600);
border-radius: 360px;
padding: 8px 24px;
cursor: pointer;
@media (max-width: 844px) {
    width:32px;
    height:32px;
   padding: 8px 2px;
   border-radius: 8px;
  } 
`;


export const DeleteButton = styled.button`
font-family: var(--font-family);
font-weight: 600;
font-size: 16px;
line-height: 137%;
text-align: center;
color: var(--colors-error-600);
gap:8px;
position: relative;
display: flex;
align-items: center;
justify-content: center;
width: calc((100% - 16px) / 2);
background:none;
border: 1px solid var(--colors-error-600);
border-radius: 360px;
padding: 8px;
cursor: pointer;
@media (max-width: 689px) {
  width: 100%;
  } 
`;
export const DeleteUse = styled.ul`
border: 1px solid var(--colors-grey-100);
border-radius: 16px;
padding: 12px 16px;
width: 224px;
height: 88px;
display: none;
position: absolute;
top:-16px;
left: 50%;
background: var(--colors-grey-25);
transform: translateX(-50%);
&.visible{
  display: block;
}
`;

export const DeleteUseItem = styled.li`
border-bottom: 1px solid var(--colors-grey-100);
padding: 0px 0px 8px 0px;
width: 100%;

font-family: var(--font-family);
font-weight: 500;
font-size: 16px;
line-height: 137%;
color: var(--colors-grey-900);
&+&{
  padding: 8px 0px 0px 0px;
  border-bottom: none;
}

`;


export const EditButton = styled(Link)`
font-family: var(--font-family);
font-weight: 600;
font-size: 16px;
line-height: 137%;
text-align: center;
color: var(--colors-primary-600);
width: calc((100% - 16px) / 2);
display: flex;
align-items: center;
justify-content: center;
gap:8px;
background:none;
border: 1px solid var(--colors-primary-600);
border-radius: 360px;
padding: 8px 24px;
cursor: pointer;
@media (max-width: 689px) {
  width: 100%;
  } 
`;

export const Fields = styled.ul`
display: flex;
flex-wrap: wrap;
gap:16px;
@media (max-width: 1024px) {
   flex-direction:column;
  } 

`;
// Загальний стиль для всіх полів кошика
export const FieldWrapper = styled.li`
border-radius: 16px;

/* padding: 16px; */
height: fit-content;
width: 100%;
height: auto;
display: flex;
gap: 16px;
@media (max-width: 1024px) {
flex-direction:row;
  } 
@media (max-width: 844px) {
flex-direction:row;
  } 
     @media (max-width: 689px) {
flex-direction:column;
  } 
  &:nth-of-type(4){
    width: 100%;
  }
  &:nth-of-type(5){
   
  }
  &:nth-of-type(6){
    justify-content: center;
   @media (max-width: 1024px) {
flex-direction:row;
  } 
  }
  &:nth-of-type(7){
 
    height: 109px;
  }
  &:nth-of-type(8){

   height: 109px;
  }


  &:nth-of-type(9){
    width: 100%;
  }
  &:nth-of-type(10){
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
 
  }


 
`;
export const SubFieldWrapper = styled.div`
border-radius: 16px;
background: var(--colors-grey-25);
padding: 16px;
min-height: 100%;
height: fit-content;
width: calc((100% - 16px) / 2);
@media (max-width: 1024px) {

  width:100%;


  height: auto;
  } 
   @media (max-width: 689px) {
width: 100%!important;
  height: fit-content;
  } 
`;
export const SubFieldWrapper1 = styled.div`
border-radius: 16px;
background: var(--colors-grey-25);
padding: 16px;
height: 100%;
width: 49%;
`;
export const SubFieldWrapper2 = styled.div`
border-radius: 16px;
background: var(--colors-grey-25);
padding: 16px;
height: 100%;
width: 100%;
min-height:191px ;
`;

export const SubFieldWrapper3 = styled.div`
border-radius: 16px;
background: var(--colors-grey-25);
padding: 16px;
height: 100%;
width: 100%;
min-height:99px ;
`;
export const MainBox = styled.div`
display: flex;
gap: 16px;

`;
export const VerticalBox = styled.div`
  display: flex;
  flex-direction:column;
  
  width: auto;

  
`;
export const HorizontalBox = styled.div`
display: flex;
align-items: center;
gap: 12px;
`;

export const HorizontalBox1 = styled.div`
width: 100%;
display: flex;
align-items: center;
gap: 12px;

`;

export const Titles = styled.p`
font-family: var(--font-family);
font-weight: 500;
font-size: 14px;
line-height: 150%;
margin-bottom: 8px;
color: var(--colors-grey-500);
box-sizing: border-box;
display:inline-block;
`;

export const Texts = styled.p`
font-family: var(--font-family);
font-weight: 500;
font-size: 16px;
line-height: 137%;
color: var(--colors-grey-900);
box-sizing: border-box;
display:flex;
white-space:wrap;
width: fit-content;
text-overflow: ellipsis;
overflow: hidden;
align-items: center;
&+&{
  margin-top: 8px;
}
`;
export const Textsp = styled.p`
font-family: var(--font-family);
font-weight: 500;
font-size: 14px;
line-height: 150%;
color: var(--colors-grey-700);
box-sizing: border-box;
width: 100%;
text-overflow: ellipsis;
overflow: hidden;
display:flex;
align-items: center;
  margin-top: 8px;

`;

export const TempLink = styled(Link)`
border-bottom: 1px solid var(--colors-primary-600);
padding: 0px 0px 2px 0px;
font-family: var(--font-family);
font-weight: 600;
font-size: 16px;
line-height: 137%;
text-align: center;
margin-left: 8px;
color: var(--colors-primary-600)
`;



// Стиль для міток
export const Label = styled.label`
font-family: var(--font-family);
font-weight: 500;
font-size: 14px;
line-height: 150%;
margin-bottom:4px;
color: var(--colors-grey-500);
box-sizing: border-box;
display:inline-block;
`;
// Стиль для міток
export const Label0 = styled.label`
font-family: var(--font-family);
font-weight: 500;
font-size: 14px;
line-height: 150%;

color: var(--colors-grey-500);
`;

export const LabelText = styled.p`
font-family: var(--font-family);
font-weight: 500;
font-size: 16px;
line-height: 137%;
color: var(--colors-grey-900);
`;

export const LabelBox = styled.div`
display: flex;
flex-direction:column;
justify-content: center;
gap: 4px;
`;



export const Label1 = styled.label`
font-family: var(--font-family);
font-weight: 500;
font-size: 14px;
line-height: 150%;
color: var(--colors-grey-900);

`;

export const Label4 = styled.label`
display: inline-block;
font-family: var(--font-family);
width: 100%;
font-weight: 500;
font-size: 14px;
line-height: 150%;
margin-bottom:4px;
color: var(--colors-grey-500);
position: relative;
&::after {
    content: '';
    display: block;
    position: absolute;
    top: 210%;
    right: 16px;
    transform: translateY(-50%);
    z-index: 500;
    width: 12px; /* Розмір іконки */
    height: 12px; /* Розмір іконки */
    background: url(${DownIcon}) no-repeat center center; /* Іконка стрілки */
    background-size: 12px 12px;
    pointer-events: none; /* Щоб іконка не перешкоджала взаємодії з селектом */
  }
`;



// Стиль для інпутів
export const Input = styled.input`
  width: 100%;
  
  height:48px;
  border: 1px solid var(--colors-grey-100);
border-radius: 360px;
padding: 8px 16px;
  font-family: var(--font-family);
font-weight: 500;
font-size: 16px;
line-height: 137%;

color: var(--colors-grey-900);
outline:none;
  &::placeholder{
    color: var(--colors-grey-400);
  }
`;

export const InputTime = styled.input`
-webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  &::-webkit-calendar-picker-indicator {
    display: none;
  }
  width: 200px;
  text-align: center;
  height:48px;
  border: 1px solid var(--colors-grey-100);
border-radius: 360px;
padding: 8px 16px;
  font-family: var(--font-family);
font-weight: 500;
font-size: 16px;
line-height: 137%;
color: var(--colors-grey-900);
outline:none;
  &::placeholder{
    color: var(--colors-grey-400);
  }
`;





// Стиль для textarea
export const TextArea = styled.textarea`
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  min-height: 211px;
  height: calc( 100% - 53px);
  resize: none;
  outline:none;
  margin-bottom: 8px;
`;

// Стиль для кнопок
export const CountLetter = styled.p`
font-family: var(--font-family);
font-weight: 500;
font-size: 14px;
line-height: 150%;
width: 100%;
color: var(--colors-grey-600);

 
  text-align: right;
`;



// Стиль для кнопок
export const Button = styled.button`
  padding: 10px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
`;




// Стиль для контейнера для перетягування фото


export const Categories = styled.ul`
  width: 100%;
display: flex;
flex-wrap:wrap;
gap:8px;
`;

export const Categorie = styled.li`
  width: auto;
  border-radius: 360px;
  padding: 4px 12px;
  height: 38px;
  justify-content: center;
  align-items: center;
  display: flex;
  border: 1px solid var(--colors-grey-50);
  background: var(--colors-grey-50);
  font-family: var(--font-family);
font-weight: 500;
font-size: 16px;
line-height: 137%;
color: var(--colors-grey-700);
&.selected{
  border: 1px solid var(--colors-secondary-300);
  background: var(--colors-secondary-50);
  color: var(--colors-secondary-600);
}
`;

// Стиль для селектів
export const Select = styled.select`
  width: 100%;
  border: 1px solid var(--colors-grey-100);
border-radius: 360px;
padding: 8px 16px;
background: var(--colors-grey-25);
outline: none;
appearance: none;
position: relative; 

`;

// Стиль для чекбоксів та радіобатонів
export const CheckBox = styled.input`
  margin-right: 10px;
  width: 20px;
  height: 20px;
`;

export const RadioButton = styled.input`
  margin-right: 10px;
  width: 16px;
  height: 16px;
  background-color: white;
`;

export const QuantityInputWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid var(--colors-grey-100);
border-radius: 360px;
padding: 4px 12px;
width: 104px;
height: 48px;
`;

export const QuantityButton = styled.button`
padding: 0;
  height: 100%;
  width:auto;
  display: flex;
  align-items: center;
  justify-content: center;
 background:none;
  cursor: pointer;
 
`;
export const InputCount = styled.input`
  width: 100%;
  padding: 0;
  width: 27px;
  font-family: var(--font-family);
font-weight: 500;
font-size: 16px;
line-height: 137%;
text-align: center;
color: var(--colors-grey-900);
  border: none
  
`;



export const ExpandableSection = styled.div`
  border-top: 1px solid var(--colors-grey-100);

  padding-top: 8px;
  width: 100%;
`;

export const RepeatSchedule = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  padding: 0px 0px 12px 0px;
  border-bottom: 1px solid var(--colors-grey-100);

`;

export const RadioGroup = styled.div`
width: 49%;
  display: flex;
  flex-direction: column;
`;

export const RadioInputGroup = styled.label`
  display: flex;
  gap:12px ;
  align-items: center;
  font-family: var(--font-family);
font-weight: 500;
font-size: 14px;
line-height: 150%;
color: var(--colors-grey-900);
  &+&{
    margin-top: 8px;
  }
 
`;





export const DayCheckboxGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  height: 108px;
`;

export const DayCheckbox = styled.div`
  width: 49%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
`;

export const DatePickerGroup = styled.div`
  display: flex;
 width: auto;
  gap: 16px;
  margin-top: 16px;
`;

export const DateRadioGroup = styled.div`
width: 49%;

  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const NumberInputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const NumberInput = styled(Input)`
  width: 80px;
  border: 1px solid var(--colors-grey-100);
border-radius: 360px;
padding: 8px 16px;
width: 80px;
height: 48px;
font-family: var(--font-family);
font-weight: 500;
font-size: 16px;
line-height: 137%;
text-align: center;
color: var(--colors-grey-900);
`;

export const InputLabel = styled(Label)`
font-family: var(--font-family);
font-weight: 500;
font-size: 14px;
line-height: 150%;
color: var(--colors-grey-700);
margin-bottom: 12px;
`;

export const InputLabel1 = styled(Label)`
display: flex;
gap: 13.5px;
align-items: center;
font-family: var(--font-family);
font-weight: 500;
font-size: 14px;
line-height: 150%;
color: var(--colors-grey-700);
margin-bottom: 12px;
`;

export const CheckBoxWrapper = styled.div`
  position: relative;
  display: inline-block;
  width: 20px;
  height: 20px;
  
  input[type="checkbox"] {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background:none;
    border: 1px solid var(--colors-grey-400);
    border-radius: 2px;
  }

  input:checked + .checkmark {
    background-color: var(--colors-secondary-500);
    border: 1px solid var(--colors-secondary-500);
  }

  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  input:checked + .checkmark:after {
    display: block;
  }

  .checkmark:after {
    top: 10%;
    left: 30%;
   
    width: 8px;
    height: 12px;
    border: solid white;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
  }
`;

export const RadioWrapper = styled.div`
  position: relative;
  display: inline-block;
  width: 16px;
  height: 16px;
  
  input[type="radio"] {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  .radioMark {
    position: absolute;
    top: 0;
    left: 0;
    height: 16px;
    width: 16px;
    background-color:  none;
    border-radius: 100%;
    border: 1px solid var(--colors-grey-400);
  }

  input:checked + .radioMark {
    background-color: none;
    border: 1px solid  var(--colors-secondary-500);

  }

  .radioMark:after {
    content: "";
    position: absolute;
    display: none;
  }

  input:checked + .radioMark:after {
    display: block;

  }

  .radioMark:after {
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background:  var(--colors-secondary-500);
  }
`;


export const CustomInput = styled.input`

  width: 219.5px;
  text-align: center;
  height:48px;
  border: 1px solid var(--colors-grey-100);
border-radius: 360px;
padding: 8px 16px;
padding-right: 40px;
  font-family: var(--font-family);
font-weight: 500;
font-size: 16px;
line-height: 137%;
color: var(--colors-grey-900);
outline:none;
position: relative;
  &::placeholder{
    color: var(--colors-grey-400);
  }
  background-color: inherit;

`;  